export default __webpack_public_path__ + "static/media/vikailmoitus.22a82b80.svg";